import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { CSVLink } from "react-csv";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import searchWhiteIcon from "../Icon.png";
// import "../OMS order list.css";
import NavBar from "../NavBar";
export default function InventoryReturns(props) {
  const [count, setCount] = useState([]);
  const [type, setType] = useState(0);
  const [filtr1, setFiltr1] = useState("");

  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => x.orderStatus === e.target.value));
    setType(0);
  };

  const handle1 = () => {
    setType(0);
  };
  const handle2 = () => {
    setType(1);
  };
  const handle3 = () => {
    setType(2);
  };
  const handle4 = () => {
    setType(3);
  };
  const handle5 = () => {
    setType(4);
  };
  const handle6 = () => {
    setType(5);
  };
  const handle7 = () => {
    setType(6);
  };
  useEffect(() => {
    if (type === 1) {
      setCount(IncomingData.filter((x) => x.orderStatus === "Pending"));
    } else if (type === 2) {
      setCount(IncomingData.filter((x) => x.orderStatus === "Approved"));
    } else if (type === 3) {
      setCount(IncomingData.filter((x) => x.orderStatus === "Shipped"));
    } else if (type === 4) {
      setCount(IncomingData.filter((x) => x.orderStatus === "Recieved"));
    } else if (type === 5) {
      setCount(IncomingData.filter((x) => x.orderStatus === "Resolved"));
    } else if (type === 6) {
      setCount(IncomingData.filter((x) => x.orderStatus === "Rejected"));
    } else {
      setCount("");
    }
    setFiltr1("");
  }, [type]);

  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Inventory Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Returns</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Returns</h2>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="OMS-main-content">
        <div className="order-list-box" style={{ width: "99%" }}>
          <div id="click-data">
            <p onClick={handle1} id={type === 0 ? "clicked-type" : ""}>
              All Products
            </p>
            <p onClick={handle2} id={type === 1 ? "clicked-type" : ""}>
              Pending
            </p>
            <p onClick={handle3} id={type === 2 ? "clicked-type" : ""}>
              Approved
            </p>
            <p onClick={handle4} id={type === 3 ? "clicked-type" : ""}>
              Shipped
            </p>
            <p onClick={handle5} id={type === 4 ? "clicked-type" : ""}>
              Received
            </p>
            <p onClick={handle6} id={type === 5 ? "clicked-type" : ""}>
              Resolved
            </p>
            <p onClick={handle7} id={type === 6 ? "clicked-type" : ""}>
              Rejected
            </p>
          </div>
          <div className="order-list-input-box">
            <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by PO number, item"
              onChange={(val) => {
                setCount(
                  IncomingData.filter((x) =>
                    x.id.match(val.target.value) || x.item.match(val.target.value)
                  )
                );
                setFiltr1("");
                setType(0);
              }}
            />              {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right">
              <select name="" id="" className="order-list-input-right-filters"
              value={filtr1}
              onChange={handleFilter1}
              >
                <option selected>Order Status</option>
                <option value="Approved">Approved</option>
                <option value="Cancelled">Cancelled</option>
                <option value="Pending">Pending</option>
                <option value="Rejected">Rejected</option>
              </select>
              <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
            </div>
          </div>
          <table style={{ textAlign: "center" }}>
            <tr>
              <th>PO number</th>
              <th>Customer</th>
              <th>Item</th>
              <th>Delivery Date</th>
              <th>Return Date</th>
              <th>Quantity</th>
              <th>Total Value</th>
              <th id='center'>Order Status</th>
            </tr>
            {count.length > 0
            ? count.map((val) => {
                return (
                  <tr>
                  <td>{val.id}</td>
                  <td>{val.customerName}</td>
                  <td>{val.item}</td>
                  <td>{val.deliveryDate}</td>
                  <td>{val.returnDate}</td>
                  <td>{val.qty}</td>
                  <td>{val.totalValue}</td>
                  <td className="col-status"
                      id={
                        val.orderStatus === "Approved"
                          ? "col-green"
                          : val.orderStatus === "Resolved"
                          ? "col-green"
                          : val.orderStatus === "Rejected"
                          ? "col-red"
                          : val.orderStatus === "Pending"
                          ? "col-yellow"
                          : val.orderStatus === "Recieved"
                          ? "col-blue"
                          : val.orderStatus === "Shipped"
                          ? "col-blue"
                          : ""
                      }>{val.orderStatus}</td>
                </tr>
                );
              })
            : IncomingData.map((val) => {
              return (
                <tr>
                  <td>{val.id}</td>
                  <td>{val.customerName}</td>
                  <td>{val.item}</td>
                  <td>{val.deliveryDate}</td>
                  <td>{val.returnDate}</td>
                  <td>{val.qty}</td>
                  <td>{val.totalValue}</td>
                  <td className="col-status"
                      id={
                        val.orderStatus === "Approved"
                          ? "col-green"
                          : val.orderStatus === "Resolved"
                          ? "col-green"
                          : val.orderStatus === "Rejected"
                          ? "col-red"
                          : val.orderStatus === "Pending"
                          ? "col-yellow"
                          : val.orderStatus === "Recieved"
                          ? "col-blue"
                          : val.orderStatus === "Shipped"
                          ? "col-blue"
                          : ""
                      }>{val.orderStatus}</td>
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
}

export const IncomingData = [
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Puma sil`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Rejected",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Shipped",
  },
  {
    id: "KCVF11222",
    customerName: "Mohit",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Rejected",
  },
  {
    id: "KCVF112L",
    customerName: "Shimmi",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Resolved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Pending",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Resolved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Pending",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Pending",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Recieved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Recieved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Approved",
  },
  {
    id: "KCVF112L",
    customerName: "John Doe",
    item: `Nike men's air zoom shoe`,
    deliveryDate: "12 - 12 - 12",
    returnDate: "15-01-13",
    qty: 5,
    totalValue: 9995,
    orderStatus: "Recieved",
  },
];
